import { DocumentStatus } from "~/components/Forms/CreateDocument/utils/utils";

export const disabledFieldsByDocumentStatus = (status: DocumentStatus) => {
  if (status === DocumentStatus.Canceled) return true;
};
